
function percentage(num) {
  const round = num.toFixed(2)
  return `${round}%`
}

export default percentage
